import  react  from "react";
import { DialogBox } from "../../shared/components/dialog";
import { DialogContent, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import useWebSocket from "../../hooks/useWebSocket";
import { RootStateType } from "../../redux/features/rootSlice";
import { webSocketMessage } from "../../config/app";
import { getLoginDeviceInfo, sessionSignout } from "../../redux/features/auth.slice";


export interface DialogProps {
open : boolean,
onClose : () => void;
selectedSessionData : {
    ssosessionid : string,
    userid : string,
    sessionid : string,
    createdate : string,
    expirationdate : string,
    uabrowser : string,
    uabrowserversion : string,
    uaos : string,
    uaosversion : string,
    uadevicetype : string,
    ipaddress : string,
    location : string,
    isCurrent : boolean
}
}

const SessionSignout = (props : DialogProps)=>{
    const { open, onClose, selectedSessionData } = props;
    const dispatch = useDispatch();
    const { updateUserAndNotifyParent } = useWebSocket();
    const {id} = useSelector(
      (state: RootStateType) => state.userStateReducer.user
    );
    const session_signout_Loading = useSelector(
      (state: RootStateType) => state.authStateReducer.setSessionSignoutLoading
    );
    const clientType = useSelector((state: RootStateType) => state.deviceConfigReducer.clientType);
    // console.log("clientType while session signout", clientType);

    const dialogClose = () =>{
        onClose();
    }

    const handleListItemClick = async () => {
        // console.log("handleListItemClick")
        const dispatchObj = {
          params : { userid: id, ssosessionid: selectedSessionData.ssosessionid },
          callBackSuccess: () => {
            updateUserAndNotifyParent(webSocketMessage.sessionSignoutResponse); 
            dispatch(getLoginDeviceInfo());
            onClose();
          },
        };
        dispatch(sessionSignout(dispatchObj));
      };

   return (
        <>
          <DialogBox
            onClose={dialogClose}
            title={"Confirm sign out"}
            buttonText={"Sign out"}
            buttonClick={handleListItemClick}
            isLoading={session_signout_Loading}
            open={open}
            style={{ maxWidth: 500, mx: "auto" }}
          >
            <DialogContent sx={{ py: 0 }}>
              <Stack direction={"row"} gap={1} alignItems={"center"}>
                <Typography>
                  Are you sure? This will sign you out of {selectedSessionData?.uabrowser} {selectedSessionData?.uaos ? `on ${selectedSessionData?.uaos}` : ""}.
                </Typography>
              </Stack>
            </DialogContent>
          </DialogBox>
        </>
      );
};

export default SessionSignout;